import React,{useState} from 'react'
import {useNavigate} from 'react-router-dom'

export default function Login(props) {
  const [credentials, setCredentials] = useState({email:"",password:""})
  const [loading,setLoading]=useState(false);
  let navigate=useNavigate();






  const handleSubmit=async (e)=>{
    e.preventDefault();
    setLoading(true);
    const response=await fetch("https://inotebook-backend-urbn.onrender.com/api/auth/login",{
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({email: credentials.email,password: credentials.password})
    });
    const json=await response.json()
    if(json.success){
      // save the auth token redirect to the page 
      localStorage.setItem('token',json.authtoken)
      setLoading(false);
      navigate("/home");
      props.showAlert("Successfully logged in","success")
    }
    else{
      setLoading(false);
      props.showAlert("Invalid Credentials","danger")
    }
  }

  const onChange=(e)=>{
    setCredentials({...credentials,[e.target.name]: e.target.value})
  }
  return (
    <div className='my-3'>
      <form onSubmit={handleSubmit}>
        <h2>Login to iNoteBook</h2>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email address</label>
          <input type="email" className="form-control" id="email" value={credentials.email} name="email" aria-describedby="emailHelp" onChange={onChange} />
          <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">Password</label>
          <input type="password" value={credentials.password} name="password" className="form-control" id="password" onChange={onChange} />
        </div>
        {
          loading? <img alt="Loading-icon" className='loading-img' src='https://www.wpfaster.org/wp-content/uploads/2013/06/loading-gif.gif'></img> : <button type="submit" className="btn btn-primary" >Submit</button>
        }
        </form>
    </div>
  )
}
